<template>
  <div>
    <v-container fluid grid-list-lg class="pa-3">
      <v-layout row wrap>
        <v-flex>
          <v-card>
            <v-toolbar dense prominent :dark="getCurrentStatusOrder(records.g_status_id)>2">
              <v-icon>bar_chart</v-icon>
              <v-toolbar-title>BTRT Assessment ({{ cache_obj._id }}: {{ records.status }})</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn small fab :href="'events_crud?uuid=73953984-a422-4608-b430-bc0f91bbcaaa&_id='+cache_obj._id" v-on="on">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Event</span>
                </v-tooltip>
              </v-toolbar-items>
            </v-toolbar>

            <v-data-table
              :headers="table.headers.filter(el=>el.visible == true)"
              :items="table.items"
              :loading="table.loading"
              must-sort
              :pagination.sync="table.pagination"
              :rows-per-page-items="table.rows_per_page_items"
              :total-items="table.total_items"
              class="elevation-1"
            >
              <v-progress-linear color="blue" indeterminate>
                <template v-slot:progress>
                </template>
              </v-progress-linear>

              <template v-slot:items="props">
                <td class="pa-1 pl-3">{{ props.item._key }}</td>
                <td class="pa-1">{{ props.item.name }}</td>
                <td class="pa-1">{{ props.item.username }}</td>
                <td class="pa-1">{{ props.item.Lcomp }}</td>
                <td class="pa-1">{{ props.item.Ldept }}</td>
                <td class="pa-1" v-html="populate_usernameDT(props.item, 'created')"></td>
                <td class="pa-1" v-html="populate_usernameDT(props.item, 'modified')"></td>
                <td class="pa-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon v-on="on"
                        v-if="!!props.item._key"
                        @click="onClick_self(props.item, props.index)"
                        :disabled="(!auth_role) && (username != props.item.username) && (!user_event_role.includes('Viewer')) && (!user_event_role.includes('Admin'))"
                      >
                        <v-icon color="primary">visibility</v-icon>
                      </v-btn>
                      <v-btn flat icon v-on="on"
                        v-else
                        @click="onClick_self(props.item, props.index)"
                        :disabled="(username != props.item.username) || (getCurrentStatusOrder(records.g_status_id)>2)"
                      >
                        <v-icon color="primary">assignment</v-icon>
                      </v-btn>
                    </template>
                    <span>Self Assessment</span>
                  </v-tooltip>
                </td>
                <td class="pa-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon v-on="on" @click="onClick_chart(props.item._key)" :disabled="!props.item._key">
                        <v-icon color="primary">bar_chart</v-icon>
                      </v-btn>
                    </template>
                    <span>View Chart</span>
                  </v-tooltip>
                </td>
                <td class="pa-1">
                  <v-list>
                    <v-list-tile
                      v-for="(i, idx) in props.item.observers"
                      :key="idx"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title style="font-size: 13px; font-weight: 400;">{{ i.name }} ({{ i.username }})</v-list-tile-title>
                        <v-list-tile-sub-title style="font-size: 12px;">{{ i.Lcomp }}: {{ i.Ldept }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon
                          v-if="!!i._key"
                          color="primary"
                          @click="onClick_observer(i, props.item._key, props.index, idx)"
                          :disabled="(!auth_role) && (username != i.username) && (!user_event_role.includes('Viewer')) && (!user_event_role.includes('Admin'))"
                        >visibility</v-icon>
                        <v-icon
                          v-else
                          color="primary"
                          @click="onClick_observer(i, props.item._key, props.index, idx)"
                          :disabled="(username != i.username) || (getCurrentStatusOrder(records.g_status_id)>2)"
                        >assignment</v-icon>
                      </v-list-tile-action>

                    </v-list-tile>
                  </v-list>
                </td>
              </template>
            </v-data-table>

          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row justify-center>
        <v-dialog
          v-model="dialog.visible"
          fullscreen hide-overlay transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar fixed dark color="#1867c0">
              <v-toolbar-title>{{ dialog.title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="onClick_close"><v-icon>close</v-icon></v-btn>
            </v-toolbar>
            <div style="padding-top: 64px;"></div>
            <v-card-title style="padding-left: 24px;" v-if="dialog.hideDT">
              <v-container class="pa-0 ma-0">
                <v-layout row wrap>
                  <v-flex xs12 md4>Created: <b>{{ dialog.created }}</b></v-flex>
                  <v-flex xs12 md4>Modified: <b>{{ dialog.modified }}</b></v-flex>
                  <v-flex xs12 md4>Key: <b>{{ dialog._key }}</b></v-flex>
                </v-layout>
              </v-container>
            </v-card-title>
            <v-card-text>
              <iframe
                :src="iframe.url"
                frameborder="0"
                width="100%"
                :height="iframe.height"
              ></iframe>

            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

    </v-container>

  </div>
</template>

<script>
import general from "../../functions/general";
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";
import query_builder from "../../functions/query.builder";

export default {
  name:"events_btrt",
	data() {
    return {
      // pageid: "",
      pageUUID: "",
      username: "",
      records: {},
      expand: [],
      table: {
        rows_per_page_items: [2, 10, 40, 70, 100],
        headers: [
          {
            text: "Key",
            class: "pa-1 pl-3",
            value: "_key",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Name",
            class: "pa-1",
            value: "name",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Username",
            class: "pa-1",
            value: "username",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Company",
            class: "pa-1",
            value: "Lcomp",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Department",
            class: "pa-1",
            value: "Ldept",
            filterable: true,
            sortable: true,
            data_type: "String",
            visible: true
          },
          {
            text: "Created",
            // align: "left",
            class: "pa-1",
            // value: "created_by",
            filterable: true,            
            sortable: false,
            data_type: "String",
            visible: true
          },
          {
            text: "Modified",
            // align: "left",
            class: "pa-1",
            // value: "created_by",
            filterable: true,            
            sortable: false,
            data_type: "String",
            visible: true
          },
          {
            text: "Self",
            // align: "left",
            class: "pa-1",
            // value: "created_by",
            filterable: false,            
            sortable: false,
            data_type: "String",
            visible: true
          },
          {
            text: "Chart",
            // align: "left",
            class: "pa-1",
            // value: "created_by",
            filterable: false,            
            sortable: false,
            data_type: "String",
            visible: true
          },
          {
            text: "Observers",
            class: "pa-1",
            // value: "obsvr_len",
            filterable: true,
            sortable: false,
            data_type: "Number",
            visible: true
          },
        ],
				items: [],
				total_items:0,
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 10,
					sortBy: "_id",
					totalItems: 100
				},
      },
      iframe: {
        url: "",
        height: "700"
      },
      dialog: {
        visible: false,
        title: "",
        created: "",
        modified: "",
        _key: "",
        hideDT: true
      },
      cache_obj: {
        _id: "",
        self_key: "",
        obs_key: "",
        idxSelf: null,
        idxObs: null
      },
      user_event_role: [],
      auth_role: false,
      auth_role_list: [],
      // thisEvent: {},
      status_option: []
    };
  },
  watch: {
    "table.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    }
  },
  async mounted () {
		general.App.set_page_title("mySuite : BTRT");
    // this.pageid = common.App.get_pageID();
    this.pageUUID = common.App.get_pageUUID();
    this.username = auth.getUsername();
    this.cache_obj._id = common.App.getQueryString("_id"); // event_id
    // Note: retrieve event status list
    this.status_option = await common.App.arango_app_selections("events", "status");

    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
    res = res.data;
    if (res.Status == 1) {
      // this.selected.roles = res.Body;
      this.auth_role_list = res.Body;
    } else {
      common.wMsgBox.Error(res.Description);
    }

    this.auth_role = common.App.check_role(this.auth_role_list, 9);

    var self = this;
    async function handleMessage(e) {
      if (e.data.event == "form_loaded") {
        self.iframe.height = e.data.window.height;
      }

      if (e.data.event == "form_data_saved_btrt") {
        common.App.loader.show(self);

        self.cache_obj.self_key = e.data.key.self_key;
        self.cache_obj.obs_key = e.data.key.obs_key;

        let res = await common.wBackEndComm.PostData("events/pub_btrt_event_save/", self.cache_obj);
        res = res.data;
        if (res.Status == 1) {
          window.location.reload();
        } else {
          common.wMsgBox.Error(res.Description);
        }
        common.App.loader.hide(self);

        self.iframe.height = e.data.window.height;
      }
    }
    window.addEventListener("message", handleMessage, false);
  },
  computed: {},
  methods: {
    epoch2localedatetime: common.App.epoch2LocaleDatetime,
		populate_usernameDT(obj, type) {
			let confiq = {
				created: {
					username: obj.created_by,
					dt: obj.created
				},
				modified: {
					username: obj.modified_by,
					dt: obj.modified
				}
			};

			let pp = [
				"<div>",
				this.epoch2localedatetime(confiq[type].dt),
				"</br>",
				confiq[type].username,
				"</div>"
			];

			pp = pp.join("");
			return pp;
		},
    onClick_observer(obvrObj, selfKey, idxSelf, idxObs) {
      if (!selfKey) {
        common.wMsgBox.Info("Pending Self Assessment to be completed.");
        return;
      }

      if (!this.cache_obj._id) {
        common.wMsgBox.Info("Please refresh the page and retry.");
        return;
      }

      this.dialog.visible = !this.dialog.visible;
      this.dialog.hideDT = true;
      this.dialog.title = "Observer Assessment";
      this.dialog.created = this.epoch2localedatetime(obvrObj.created) + " - " + obvrObj.created_by;
      this.dialog.modified = this.epoch2localedatetime(obvrObj.modified) + " - " + obvrObj.modified_by;
      this.dialog._key = obvrObj._key;

      var temp_url_self = [
        comm.BTRT_url,
        "btrt_form_obsvr_r1/?key=",
        obvrObj._key,
        "&Nname=",
        obvrObj.name,
        "&username=",
        obvrObj.username,
        "&Ckey=",
        selfKey
      ];

      this.iframe.url = temp_url_self.join("");

      this.cache_obj.idxSelf = idxSelf;
      this.cache_obj.idxObs = idxObs;
    },
    onClick_self(selfObj, idxSelf) {
      if (!this.cache_obj._id) {
        common.wMsgBox.Info("Please refresh the page and retry.");
        return;
      }

      this.dialog.visible = !this.dialog.visible;
      this.dialog.hideDT = true;
      this.dialog.title = "Self Assessment";
      this.dialog.created = this.epoch2localedatetime(selfObj.created) + " - " + selfObj.created_by;
      this.dialog.modified = this.epoch2localedatetime(selfObj.modified) + " - " + selfObj.modified_by;
      this.dialog._key = selfObj._key;

      var temp_url_self = [
        comm.BTRT_url,
        "btrt_form_r1/?key=",
        selfObj._key,
        "&Nname=",
        selfObj.name,
        "&username=",
        selfObj.username
      ];

      this.iframe.url = temp_url_self.join("");

      this.cache_obj.idxSelf = idxSelf;
    },
    onClick_chart(selfKey) {
      this.dialog.visible = !this.dialog.visible;
      this.dialog.hideDT = false;
      this.dialog.title = "Assessment Profile";
      this.dialog.created = "";
      this.dialog.modified = "";
      this.dialog._key = "";

      var temp_url_chart = [
        comm.BTRT_url,
        "graph_btrt_r1/?key=",
        selfKey,
        "&readOnly=true"
      ];

      this.iframe.url = temp_url_chart.join("");
    },
    onClick_close() {
      this.dialog.visible = false;
      this.dialog.hideDT = true;
      this.dialog.title = "";
      this.dialog.created = "";
      this.dialog.modified = "";
      this.dialog._key = "";
      this.iframe.url = "";

      this.cache_obj.idxSelf = null;
      this.cache_obj.idxObs = null;
    },
    async refreshData() {
      common.App.loader.show(this);

      let res = await common.wBackEndComm.GetData("events/events_listing/?_id="+this.cache_obj._id);
      res = res.data;
      if (res.Status == 1) {
        this.records = res.Body[0].records[0];
				this.table.items = res.Body[0].records[0].data.candidates;
				this.table.total_items = this.table.items.length;

        // Note: get event-roles.
        var r = this.records.collaborators.filter(e => e.username==this.username);
        var len = r.length;
        for (let i = 0; i < len; i++) {
          let len1 = r[i].role.length;
          for (let j = 0; j < len1; j++) {
            if (r[i].role[j].value == true) {
              this.user_event_role.push(r[i].role[j].name);
            }
          }
        }
        this.user_event_role = [...new Set(this.user_event_role)];
      } else {
        common.wMsgBox.Error(res.Description);
      }
      common.App.loader.hide(this);
    },
    getCurrentStatusOrder(cur_status_id="") {
      var val = null;
      var obj = this.status_option.find(function(el){
        return el._id==cur_status_id;
      });

      if (obj){
        val = obj.order;
      }
      return val;
    },
    get_component_path(pageUUID) {
			var menu = auth.getMenu().concat(auth.getMenu_int());
			var temp = menu.filter(function (el) {
				return el.uuid == pageUUID;
			});
			return temp[0].component_path.event_type;
		},
  }
};
</script>

<style></style>